/**
 * ms-similares — trae productos que comparten el valor de un metacampo con el
 * de la ficha (familia, categoria, linea: lo que la seccion tenga configurado).
 *
 * La seccion le pasa por data- la URL ya armada con el filtro de metafield y
 * la vista ligera (templates/collection.ms-similares.liquid), que devuelve
 * solo tarjetas. Aqui solo se pide, se quita el producto que ya se esta
 * viendo, y se inyecta.
 *
 * Se pide SOLO al entrar en pantalla: la seccion vive abajo del pliegue y la
 * velocidad es la fuga #1 del audit. No hay razon para gastar una peticion
 * en alguien que nunca baja.
 */
if (!customElements.get('ms-similares')) {
  class MsSimilares extends HTMLElement {
    connectedCallback() {
      // Al agregar al carrito la página redibuja esta sección (morph): el
      // elemento se queda, pero pierde data-cargado y vuelve a los huecos del
      // esqueleto, y connectedCallback no se repite. Se vigila ese atributo y se
      // repinta con lo que ya se trajo (la fila quedaba en gris).
      if (!this.mo) {
        this.mo = new MutationObserver(() => {
          if (!this.dataset.cargado && this.htmlCache) {
            this.dataset.cargado = '1';
            this.pintar(this.htmlCache);
          }
        });
        this.mo.observe(this, { attributes: true, attributeFilter: ['data-cargado'] });
      }

      if (this.dataset.cargado) return;

      const arranque = () => {
        if (this.dataset.cargado) return;
        this.dataset.cargado = '1';
        this.cargar();
      };

      if (!('IntersectionObserver' in window)) return arranque();

      this.io = new IntersectionObserver(
        (entradas) => {
          if (entradas.some((e) => e.isIntersecting)) {
            this.io.disconnect();
            arranque();
          }
        },
        { rootMargin: '400px' }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.mo) {
        this.mo.disconnect();
        this.mo = null;
      }
    }

    async cargar() {
      try {
        const html = await fetch(this.dataset.url).then((r) => {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        });
        this.htmlCache = html;
        this.pintar(html);
      } catch (e) {
        // Una fila de recomendaciones nunca justifica romper la ficha.
        this.vaciar();
      }
    }

    pintar(html) {
      this.dataset.cargado = '1';
      const max = parseInt(this.dataset.max, 10) || 4;
      const excluir = this.dataset.excluir;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const tarjetas = Array.from(doc.body.children).filter((el) => {
        const a = el.querySelector('a[href*="/products/"]');
        return !a || !a.getAttribute('href').includes('/products/' + excluir);
      });

      if (!tarjetas.length) return this.vaciar();
      this.replaceChildren(...tarjetas.slice(0, max));
    }

    vaciar() {
      // Se quita la seccion COMPLETA, no solo el contenedor: el div de fondo
      // es hermano y quedaria pintando una franja vacia.
      const cont = this.closest('.shopify-section') || this.closest('.ms-sim');
      if (cont) cont.remove();
    }
  }

  customElements.define('ms-similares', MsSimilares);
}
